export default "__VITE_ASSET__DLMsgnY1__"